import { h } from 'maquette'

import Base from './action-base'

export default class DisableTorch extends Base
  Object.defineProperty this, "label", get: -> @t(".label")
  @icon = "fa-power-off"

  renderFields: =>
    h('div', [@t('.no_settings')])
